/**
 * Service notes on a device: what was done on site and when ("replaced the antenna", "swapped
 * the LoRa card", "new motherboard, old one back to the workshop"). A log people can read later
 * when a device plays up, so the history of the hardware isn't only in someone's head.
 *
 * FMS staff and installers write them; everyone who can see the device can read them.
 */
export type NoteKind = "visit" | "antenna" | "lora-card" | "motherboard" | "power" | "sensor" | "firmware" | "other";

export const NOTE_KINDS: Record<NoteKind, string> = {
  visit: "Site visit",
  antenna: "Antenna replaced",
  "lora-card": "LoRa card replaced",
  motherboard: "Motherboard replaced",
  power: "Power / battery / solar",
  sensor: "Sensor or wiring",
  firmware: "Firmware updated",
  other: "Other",
};

export interface DeviceNote {
  id: string;
  devEui: string;
  accountId: string;
  kind: NoteKind;
  text: string;
  /** When the work was done (can be logged afterwards). */
  at: number;
  /** Who wrote it: name, and their user id so they can delete their own. */
  by: string;
  byId: string;
  createdAt: number;
}

export function isNoteKind(k: unknown): k is NoteKind {
  return typeof k === "string" && k in NOTE_KINDS;
}
